import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';

export const Sidebar = withSuspense(
	lazy(() => import('./sidebar.component')),
	null,
);
